(() => {
  const SELECTOR = '.card__picture-container--gallery';

  class CardGallery {
    constructor(container) {
      this.container = container;
      this.image = container.querySelector('[data-card-gallery-image], .card__img:not(.card__img--hover)');
      this.prevButton = container.querySelector('[data-card-gallery-prev]');
      this.nextButton = container.querySelector('[data-card-gallery-next]');
      this.index = 0;
      this.images = this.parseImages();

      if (!this.image || !this.images.length || this.images.length < 3) {
        return;
      }

      this.bindEvents();
    }

    parseImages() {
      const script = this.container.querySelector('[data-card-gallery-images]');
      if (!script) return [];

      try {
        const parsed = JSON.parse(script.textContent);
        return Array.isArray(parsed) ? parsed.filter((item) => item && item.src) : [];
      } catch (error) {
        return [];
      }
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.show(this.index - 1);
      });

      this.nextButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.show(this.index + 1);
      });
    }

    show(nextIndex) {
      const total = this.images.length;
      this.index = ((nextIndex % total) + total) % total;
      const item = this.images[this.index];
      if (!item) return;

      this.image.src = item.src;
      if (item.srcset) {
        this.image.srcset = item.srcset;
      }
      if (item.width) {
        this.image.width = item.width;
      }
      if (item.height) {
        this.image.height = item.height;
      }
    }
  }

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((container) => {
      if (container.dataset.cardGalleryReady === 'true') return;
      container.dataset.cardGalleryReady = 'true';
      new CardGallery(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
